import Icon from 'veui/components/Icon'
import { IconLineChart } from 'dls-icons-vue'

Icon.register('line-chart', IconLineChart)
